import { TIME } from '@custom/dx3';

/**
 * Number of milliseconds before <AuthProvider> proactively logs us out by
 * redirecting to the logout endpoint
 * (https://xfinityxchange2.performnet.com/xfinityxchange2/logout.do)
 *
 * The proactive client-side auto-logout is necessary because the OIDC
 * /token endpoint may keep the Java session alive indefinitely
 */
export const LOGOUT_TIME = parseInt(
  // The value `TIME.MINUTE * 60` is only used as a fallback.
  // In production builds, we use the value of LOGOUT_TIME from
  // <project root>/production.env
  process.env.LOGOUT_TIME || TIME.MINUTE * 60 + ''
);
